// 用于交付报告
let statisticsUrl = [
    '/member/v2/project/lists',  //全部项目
    '/member/v2/programme/index',  //3D设计方案
    '/member/v2/mynews/index',  //我的消息
    '/member/v2/team/index',  //项目团队
    '/member/v2/contract/survey',  //合同备忘
    '/member/v2/evaluate/finish',  //竣工评价
    '/member/v2/ievaluate/evaluate',  //我要评价
    // '/member/v2/index/index',  //首页
    '/member/v2/schedule/index',  //项目日志
    '/member/v2/process/index',  //报告列表
    '/member/v2/evaluation/index',  //隐蔽系统施工评价
    '/member/v2/process/detail',  //报告详情
    '/member/v2/standard/index',//施工标准
    //app端
    '/member/v3/project/lists',  //全部项目
    '/member/v3/programme/index',  //3D设计方案
    '/member/v3/mynews/index',  //我的消息
    '/member/v3/team/index',  //项目团队
    '/member/v3/contract/survey',  //合同备忘
    '/member/v3/evaluate/finish',  //竣工评价
    '/member/v3/ievaluate/evaluate',  //我要评价
    // '/member/v3/index/index',  //首页
    '/member/v3/schedule/index',  //项目日志
    '/member/v3/process/index',  //报告列表
    '/member/v3/evaluation/index',  //隐蔽系统施工评价
    '/member/v3/process/detail',  //报告详情
];

let arrFileUrl = [
    '/archives/dossier/aftersale',// 售后维保
    '/archives/evaluate/index',// 客户评价
    '/archives/workOrder/details',// 定位交底
    '/archives/design/details',// 3D设计方案
    '/archives/design/change',// 变更记录
    '/archives/dossier/log',// 跟进日志
    '/archives/dossier/contract',// 合同信息
    '/archives/contract',// 合同详情(项目变更单)
    '/archives/contract/record',// 变更记录
    '/hvac/dossier/warm',// 用户卷宗首页
    '/archives/dossier',// 用户卷宗详情
    '/archives/survey/designinfo',
    '/archives/construction/index',// 施工进度
    '/archives/followup',// 跟进记录
    '/archives/flow',// 工单详情
    '/archives/rectify',// 工单详情
    '/archives/disclose',// 工单详情
    '/archives/survey/reportinfo',// 勘察报告详情
]
let arrReportAuth = [
    "/member/v2/process/index",
    "/member/v2/process/detail",
    "/member/v2/contract/survey",
    "/member/v2/programme/index",
    "/member/v2/evaluation/index",
    "/member/v2/evaluate/finish",
    "/member/v2/ievaluate/evaluate",
    "/member/v2/team/index",
    "/member/v2/mynews/index",
    "/member/v2/index/index"
]
export  default {
    statisticsUrl,
    arrFileUrl,
    arrReportAuth
}
